import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Index.vue";
import OnChinaEntropy from "../views/on-china-entropy/main.vue";
import JoinUs from "../views/join-us/Index.vue";
import JobList from "../views/join-job-list/Index.vue";
import JobInfos from "../views/join-job-infos/Index.vue";
import BrandHonor from "../views/brand-honor/Index.vue";
import ProductCenter from "../views/product-center/Index.vue";
import Solution from "../views/solution/Index.vue";
import SolutionDetail from "../views/solution-detail/Index.vue";
// import SoftwareProduct from "../views/software-product/Index.vue";
import SoftwareProductDetail from "../views/product-detail/soft/Index.vue";
// import HardwareProduct from "../views/hardware-product/Index.vue";
import HardwareProductDetail from "../views/product-detail/hard/Index.vue";
import WinterOlympics from "../views/winter-olympics/Index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      headerTheme: "transparent",
      keepAlive: false,
    },
  },
  {
    path: "/winter-olympics",
    name: "WinterOlympics",
    component: WinterOlympics,
    meta: {
      headerTheme: "dark",
      keepAlive: false,
    },
  },
  {
    path: "/on-china-entropy",
    name: "OnChinaEntropy",
    component: OnChinaEntropy,
    meta: {
      headerTheme: "dark",
      keepAlive: false,
    },
  },
  {
    path: "/join-us",
    name: "JoinUs",
    component: JoinUs,
    meta: {
      headerTheme: "transparent",
      keepAlive: false,
    },
  },
  {
    path: "/job-list/:type/:jobType",
    name: "JobList",
    component: JobList,
    meta: {
      headerTheme: "transparent",
      keepAlive: false,
    },
  },
  {
    path: "/job-infos/:type/:name/:jobCode/:districtCode",
    name: "JobInfos",
    component: JobInfos,
    meta: {
      headerTheme: "dark",
      keepAlive: false,
    },
  },
  {
    path: "/brand-honor",
    name: "BrandHonor",
    component: BrandHonor,
    meta: {
      headerTheme: "dark",
      keepAlive: false,
    },
  },
  {
    path: "/product-center",
    name: "ProductCenter",
    component: ProductCenter,
    meta: {
      headerTheme: "light",
      keepAlive: false,
    },
  },
  {
    path: "/solution",
    name: "Solution",
    component: Solution,
    meta: {
      headerTheme: "transparent",
      keepAlive: false,
    },
  },
  {
    path: "/solution/detail",
    name: "SolutionDetail",
    component: SolutionDetail,
    meta: {
      headerTheme: "transparent",
      keepAlive: false,
    },
  },
  // {
  //   path: "/software-product",
  //   name: "SoftwareProduct",
  //   component: SoftwareProduct,
  //   meta: {
  //     headerTheme: "dark",
  //     keepAlive: false,
  //   },
  // },
  // {
  //   path: "/software-product-detail/:typeCode/:code",
  //   name: "SoftwareProductDetail",
  //   component: SoftwareProductDetail,
  //   meta: {
  //     headerTheme: "light",
  //     keepAlive: false,
  //   },
  // },
  // // {
  // //   path: "/hardware-product",
  // //   name: "HardwareProduct",
  // //   component: HardwareProduct,
  // //   meta: {
  // //     headerTheme: "dark",
  // //     keepAlive: true,
  // //   },
  // // },
  // {
  //   path: "/hardware-product-detail/:typeCode/:code",
  //   name: "HardwareProductDetail",
  //   component: HardwareProductDetail,
  //   meta: {
  //     headerTheme: "light",
  //     keepAlive: false,
  //   },
  // },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
